const ANIMATION_DURATION = 0.4;

export {
    ANIMATION_DURATION
}